import PendingActions from "./components/PendingActions";
import ActiveUser from "./components/ActiveUser";
import PendingUser from "./components/PendingUser";
import ActiveActions from "./components/ActiveActions";
import InactiveActions from "./components/InactiveActions";
import { checkGroup, GetRevoked, MakeHyperLink } from "./components/UserTableRenderers";
import React from 'react';


export const UserGridTableDef: any = {
    pendingIso: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                cellRenderer: MakeHyperLink
            },

        ],
        moreInfo: PendingUser,
        rowActions: PendingActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    pendingNida: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                cellRenderer: MakeHyperLink
            },

        ],
        moreInfo: PendingUser,
        rowActions: PendingActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    pendingUser: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                headerName: "DUC Type",
                flex: 2,
                cellRenderer: checkGroup
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                cellRenderer: MakeHyperLink
            },

        ],
    },
    active: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                field: "expiryDate",
                headerName: "DUC Expiration Date",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                field: "signingUrl",
                headerName: "DUC Status",
                flex: 2,
                cellRenderer: MakeHyperLink
            },
            {
                field: "revokeDuc",
                headerName: "Revoke DUC",
                filter: 'agTextColumnFilter',
                flex: 2,
                cellRenderer: GetRevoked,
            },
        ],
        moreInfo: ActiveUser,
        rowActions: ActiveActions,
        showHide: ["labPosition", "labPI", "role"],
    },
    inactive: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
            {
                field: "expiryDate",
                headerName: "DUC Expiration Date",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
        ],
        moreInfo: React.Fragment,
        rowActions: InactiveActions,
    },
    rejected: {
        columns: [
            {
                field: "firstName",
                headerName: "First name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "lastName",
                headerName: "Last name",
                sortable: true,
                filter: 'agTextColumnFilter',
                flex: 1.5,
            },
            {
                field: "email",
                sortable: true,
                headerName: "Email",
                filter: 'agTextColumnFilter',
                flex: 2,
            },
        ],
        moreInfo: React.Fragment,
    },
};
